import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import classnames from 'classnames';

var Progress = /*#__PURE__*/function (_PureComponent) {
  _inherits(Progress, _PureComponent);

  var _super = _createSuper(Progress);

  // 线条粗细表
  function Progress(props) {
    var _this;

    _classCallCheck(this, Progress);

    _this = _super.call(this, props);
    _this.progressElement = void 0;
    _this.state = {
      svgStrokeWidth: _this.strokeWidth
    };
    return _this;
  }

  _createClass(Progress, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.useSVG) {
        this.resetSVGStrokeWidth();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;

      if (prevProps.strokeWidth !== props.strokeWidth) {
        this.resetSVGStrokeWidth();
      }
    }
  }, {
    key: "useSVG",
    get: function get() {
      var props = this.props;
      return props.shape === 'semi-circle' || props.shape === 'circle';
    }
  }, {
    key: "strokeWidth",
    get: function get() {
      var _this$props = this.props,
          strokeWidth = _this$props.strokeWidth,
          size = _this$props.size;
      var strokeWeights = Progress.strokeWeights;
      var backup = strokeWeights[size && size in strokeWeights ? size : 'md'];
      return Math.max(1, strokeWidth || backup);
    }
  }, {
    key: "resetSVGStrokeWidth",
    value: function resetSVGStrokeWidth() {
      var baseWidth = 32;
      var clientWidth = this.progressElement.clientWidth;
      this.setState({
        svgStrokeWidth: baseWidth / clientWidth * this.strokeWidth
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames,
          _this2 = this;

      var _this$props2 = this.props,
          theme = _this$props2.theme,
          percent = _this$props2.percent,
          strokeShape = _this$props2.strokeShape,
          shape = _this$props2.shape,
          size = _this$props2.size,
          style = _this$props2.style,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          children = _this$props2.children,
          format = _this$props2.text;
      var state = this.state;
      var strokeWidth = this.useSVG ? state.svgStrokeWidth : this.strokeWidth;
      var hasKnownSize = size && size in Progress.strokeWeights;
      var cls = classnames(prefixCls, className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "--").concat(shape), !!shape), _defineProperty(_classnames, "".concat(prefixCls, "--").concat(theme), !!theme), _defineProperty(_classnames, "".concat(prefixCls, "--").concat(size), hasKnownSize), _classnames));
      var sizeStyle = {};

      if (!hasKnownSize) {
        sizeStyle.width = size;

        if (shape === 'circle') {
          sizeStyle.height = size;
        }

        if (shape === 'semi-circle') {
          if (typeof size === 'number') {
            sizeStyle.height = "".concat(size / 2, "px");
          } else if (typeof size === 'string') {
            sizeStyle.height = size.replace(/^(\d+)(.+)$/, function () {
              return parseFloat(arguments.length <= 1 ? undefined : arguments[1]) / 2 + (arguments.length <= 2 ? undefined : arguments[2]);
            });
          }
        }
      }

      var diameter = 32;
      var radius = diameter / 2;
      var extendRadius = radius + strokeWidth / 2;
      var strokeLinecap = strokeShape === 'round' ? 'round' : 'butt';
      var viewBox = shape === 'circle' ? "0 0 ".concat(diameter + strokeWidth, " ").concat(diameter + strokeWidth) : "0 0 ".concat(diameter + strokeWidth, " ").concat((diameter + strokeWidth) / 2);
      var path = shape === 'circle' ? "\n        M".concat(extendRadius, ", ").concat(extendRadius, "\n        m0 ").concat(-radius, "\n        a").concat(radius, " ").concat(radius, " 0 1 1 0 ").concat(diameter, "\n        a").concat(radius, " ").concat(radius, " 0 1 1 0 ").concat(-diameter) : "\n        M".concat(extendRadius, ", ").concat(extendRadius, "\n        m").concat(-radius, " 0\n        a").concat(radius, " ").concat(radius, " 0 0 1 ").concat(diameter, " 0");
      var dasharray = shape === 'circle' ? Math.PI * diameter : Math.PI * diameter / 2;
      var borderRadius = strokeShape === 'round' ? "".concat(this.strokeWidth, "px") : '0';
      var lineTrackStyle = {
        height: "".concat(strokeWidth),
        borderRadius: borderRadius
      };
      var lineThumbStyle = {
        width: "".concat(percent, "%"),
        height: "".concat(strokeWidth, "px"),
        borderRadius: borderRadius
      };
      var formattedPercent = format ? format(percent || 0) : null;
      var hasIndicator = children || formattedPercent;
      var roundInner = (shape === 'circle' || shape === 'semi-circle') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
        viewBox: viewBox
      }, /*#__PURE__*/React.createElement("path", {
        className: "".concat(prefixCls, "__track"),
        d: path,
        strokeWidth: strokeWidth,
        strokeLinecap: strokeLinecap
      }), /*#__PURE__*/React.createElement("path", {
        className: "".concat(prefixCls, "__thumb"),
        d: path,
        strokeWidth: strokeWidth,
        strokeLinecap: strokeLinecap,
        strokeDasharray: dasharray,
        strokeDashoffset: dasharray * (100 - percent) / 100
      })), hasIndicator && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__text")
      }, children || formattedPercent));
      var rectInner = shape === 'line' && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__outer")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__track"),
        style: lineTrackStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__thumb"),
        style: lineThumbStyle
      })), hasIndicator && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__text")
      }, children || formattedPercent));
      return /*#__PURE__*/React.createElement("div", {
        className: cls,
        style: _objectSpread(_objectSpread({}, sizeStyle), style),
        ref: function ref(ele) {
          _this2.progressElement = ele;
        }
      }, shape === 'line' ? rectInner : roundInner);
    }
  }]);

  return Progress;
}(PureComponent);

Progress.defaultProps = {
  prefixCls: 'za-progress',
  theme: 'primary',
  shape: 'line',
  size: 'md',
  percent: 0,
  strokeShape: 'round',
  text: function text(percent) {
    return "".concat(percent, "%");
  }
};
Progress.strokeWeights = {
  lg: 10,
  md: 8,
  sm: 4
};
export { Progress as default };